import { createMiddleware } from "@tanstack/react-start";

import { resolveRequestGameContext } from "#/server/game/requestGameContext.server";

export const gameContextMiddleware = createMiddleware({ type: "function" }).server(
  async ({ next }) => next({ context: { gameContext: await resolveRequestGameContext() } }),
);
